import { createClient } from '@supabase/supabase-js';

// Fallback-Werte verhindern einen App-Absturz, falls Supabase noch nicht verbunden ist.
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || 'https://placeholder.supabase.co';
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || 'public-anon-key-placeholder';

if (!import.meta.env.VITE_SUPABASE_URL || !import.meta.env.VITE_SUPABASE_ANON_KEY) {
  console.warn('⚠️ Supabase ist noch nicht verbunden. Formular-Daten können aktuell nicht gespeichert werden. Bitte oben rechts auf "Connect Supabase" klicken.');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);